import { MonitorCog, Settings, Shield, UserRound, Users } from 'lucide-react';
import {
  TresholdsTabContent,
  ProfileTabContent,
  SecurityTabContent,
  SystemTabContent,
  UserManagementTabContent,
} from './components';

export type SettingsTabKey =
  | 'profile'
  | 'system'
  | 'thresholds'
  | 'security'
  | 'users';

export interface SettingsTabConfig {
  key: SettingsTabKey;
  label: string;
  description: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  component: React.ComponentType;
}

export const SETTINGS_TABS: SettingsTabConfig[] = [
  {
    key: 'profile',
    label: 'Profile',
    description: 'Manage your commander profile, role, and contact details.',
    icon: UserRound,
    component: ProfileTabContent,
  },
  {
    key: 'system',
    label: 'System',
    description: 'Control unit preferences, time format, and system behavior.',
    icon: MonitorCog,
    component: SystemTabContent,
  },
  {
    key: 'thresholds',
    label: 'Thresholds',
    description: 'Configure mission thresholds.',
    icon: Settings,
    component: TresholdsTabContent,
  },
  {
    key: 'security',
    label: 'Security',
    description: 'Adjust authentication, access, and security policies.',
    icon: Shield,
    component: SecurityTabContent,
  },
  {
    key: 'users',
    label: 'Users',
    description: 'Manage application users and their roles.',
    icon: Users,
    component: UserManagementTabContent,
  },
];

export const DEFAULT_TAB: SettingsTabKey = 'profile';

export function isValidSettingsTab(
  value: string | null
): value is SettingsTabKey {
  return SETTINGS_TABS.some((tab) => tab.key === value);
}
